import Fab from './fab';
import './hide';
import { initializeComments } from './comments';
import { initializeLanguageMenu } from './languageMenu';
import { initializeCollapsibleSearch } from './collapsibleSearch';
import { initializeSessionManager } from './sessionManager';
import { initializeHashHighlightManager } from './hashHighlightManager';
import { initializeHashUpdateManager } from './hashUpdateManager';
import { initPostsListAsync } from './postsList';
import { initializeWpApiSettingsNonceRefresh } from './restApi/wpApiSettings';

const fab = new Fab();

fab.showOnScroll();

initializeWpApiSettingsNonceRefresh();
initializeLanguageMenu();
initializeSessionManager();
initializeComments();
initializeCollapsibleSearch();
initializeHashHighlightManager();
initializeHashUpdateManager(8 * 10);
initPostsListAsync();